// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const AsymmetricKeySource = {
    jwks: (value) => {
        return Object.assign(Object.assign({}, value), { type: "jwks", _visit: function (visitor) {
                return FernIr.AsymmetricKeySource._visit(this, visitor);
            } });
    },
    static: (value) => {
        return Object.assign(Object.assign({}, value), { type: "static", _visit: function (visitor) {
                return FernIr.AsymmetricKeySource._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "jwks":
                return visitor.jwks(value);
            case "static":
                return visitor.static(value);
            default:
                return visitor._other(value);
        }
    },
};
